import config from 'configDir/index';
import { get } from './http';

// 查询车辆最新定位列表
const latestBatchService = get('/location/latest/batch', config.terminalUrl);

// 查询车辆最新定位聚合
const mapAggregateService = get('/location/mapAggregate', config.terminalUrl);

// 查询车辆流量
const latestBatchStatisticsService = get('/location/latest/batch/statistics', config.terminalUrl);

// 查询车辆实时流向
const queryCarRealTimeFlowService = get(
  '/latest/location/carRealTimeFlowDirect',
  config.terminalUrl,
);

// 查询车辆历史轨迹
const listByTimeTervalService = get('/location/listByTimeTerval', config.terminalUrl);

// 查询车辆线路
const queryCarRoute = get('/location/listStaticLoc', config.terminalUrl);

// 展板基本信息总量
const panelBaseInfoService = get('/panel/base/info/total', config.resourceUrl);

// 展板头部车辆信息总量
const panelTypeStatService = get('/panel/type/statistical', config.resourceUrl);

// 展板人车户柱状图统计
const getBasicInfoStatService = get('/panel/type/summaryThreeDate', config.resourceUrl);

// 资质到期个数
const totalExpiredNumService = get('/alarmPanelStatistical/totalExpiredNum', config.serviceUrl);

// 未完成违规培训企业
const notFinishedStudy = get('/safe/study/notfinished', config.governanceUrl);

// 五率分析（行业端）
const fiveRateCountService = get('/five/analysis/rate/count', config.discoveryCenterServiceUrl);

// 五率分析（企业端）
const fiveRateCountCompanyService = get(
  '/five/analysis/enterprise/count',
  config.discoveryCenterServiceUrl,
);

// 近7天人工处理情况（企业端）
const sevenDayManualHandleSituationService = get(
  '/alarmPanelStatistical/sevenDayManualHandleSituation',
  config.discoveryCenterServiceUrl,
);

// 今日报警（企业端）
const totalAlarmTodayService = get(
  '/alarmPanelStatistical/totalAlarmToday',
  config.discoveryCenterServiceUrl,
);

// 实时在线车辆（企业端）
const vehicleRunStatusService = get('/vehicle_stat/status/count', config.terminalUrl);

// 车辆运行状态
const aggrVehicleStatusService = get('/latest/location/aggrVehicleStatus', config.terminalUrl);

// 累计投诉情况（企业端）
const getListForComparedService = get(
  '/evaluationComplaint/getListForCompared',
  config.commonServiceUrl,
);

// 查询危货流向和吞吐量
const queryDangerWayBillchangeService = get('/panel/danger/queryWaybillchange', config.resourceUrl);

// 查询车辆位置和订单状态
const queryVehicleWaybillService = get('/panel/danger/queryVehicleWaybill', config.resourceUrl);

// 查询危货订单状态
const queryWaybillCountGroupbyStatusService = get(
  '/panel/danger/queryWaybillCountGroupbyStatus',
  config.resourceUrl,
);

// 查询危货货物分析
const queryWaybillCountGroupByTypeService = get(
  '/panel/danger/queryWaybillCountGroupbyType',
  config.resourceUrl,
);

// 查询危货异常数据
const queryAbnormalWaybillNumService = get(
  '/panel/danger/queryAbnormalWaybillNum',
  config.resourceUrl,
);

// 查询危货热点企业情况
const queryHotWaybillService = get('/panel/danger/queryHotWaybill', config.resourceUrl);

// 查询近5日货物吞吐量
const queryWaybillFlowChangeService = get(
  '/panel/danger/queryWaybillFlowchange',
  config.resourceUrl,
);

// 辅助策略-区域交通运力-货运总运距柱状图接口（用于查询营运类型的每日总里程）
const capacityMileageService = get(
  '/five/analysis/capacity/mileage',
  config.discoveryCenterServiceUrl,
);

// 查询公交线路
const queryBusLineService = get('/bus/route/queryRoute/page', config.customizationWcUrl);

// 根据车型查询投诉处理情况
const getListForCarTypeService = get(
  '/evaluationComplaint/getListForCarType',
  config.commonServiceUrl,
);

// 查询路网信息列表接口
const queryRoadInfoCollectionList = get('/roadInfoCollection/query', config.commonServiceUrl);

// 随机获取一个源头企业
const queryRandomEnterprise = get('/sourceEnterprise/random', config.resourceUrl);

// 行业企业近30天违章情况(新)
const statCarVioTrendService = get('/im/stat_car_vio_trend', config.governanceUrl);

// 根据车型查询近30天违章情况(新)
const statCarVioTrendByOperateService = get(
  '/im/stat_car_vio_trend_by_operate',
  config.governanceUrl,
);

// 查询重货普货30天违章趋势(新)
const statWeightAndCommonVioTendService = get(
  '/im/stat_weight_and_common_vio_tend',
  config.governanceUrl,
);

// 查询驾培维修30天违章趋势(新)
const statDrischoolAndRepairVioTendService = get(
  '/im/stat_drischool_and_repair_vio_tend',
  config.governanceUrl,
);

// 近期旅游包车的违章数据
const statRecentlyRehicleExService = get('/im/stat_recently_rehicle_ex', config.governanceUrl);

// 查询重货普货7日排名
const statCarVioRankService = get('/im/stat_car_vio_rank', config.governanceUrl);

// 查询源头企业列表（暂时接口，后续会换成查询流量排名的源头企业）
const searchSourceEnterpriseService = get('/sourceEnterprise/search', config.resourceUrl);

// 维修驾培展板基本信息总量
const panelMtdvBaseInfoTotalService = get('/panel/mtdv/base/info/total', config.resourceUrl);

//
const fiveAnalysisBusRunningService = get(
  '/five/analysis/bus/running',
  config.discoveryCenterServiceUrl,
);

// 查询公交热点线路排名
const panelBusHotLineService = get('/panel/bus/hotLine', config.customizationWcUrl);

// 查询平台检测车辆问题分页
const queryCarProblemService = get('/violation/page', config.governanceUrl);

//  查询企业
const queryEnterpriseService = get('/enterprise/queryEnterprise', config.resourceUrl);

//  查询源头企业
const querySourceEnterpriseService = get('/sourceEnterprise/search', config.resourceUrl);

//  请求违章聚集集合点
const queryViolationFrequentService = get('/violation/frequent', config.governanceUrl);
// 热力图
const queryVioHeatMapService = get('/vioHeatMap/statVioHeatMap', config.governanceUrl);
// 粗颗粒
const queryVioHeatMapCoarseStatService = get(
  '/vioHeatMap/coarseStatVioHeatMap',
  config.governanceUrl,
);
// 细颗粒
const queryVioHeatMapFineStatService = get('/vioHeatMap/fineStatVioHeatMap', config.governanceUrl);

// 违章数
const queryVioCarCountService = get('/vioHeatMap/stat_car_vio', config.governanceUrl);

// 获取设备列表
const vcloudDeviceListService = get('/vcloud/device/list', config.dockingSystemServiceUrl);

// 通过通道码播放指定设备
const vcloudMediaPlayService = get('/vcloud/media/play', config.dockingSystemServiceUrl);

// 通过播放id停止播放指定设备
const vcloudMediaStopplayService = get('/vcloud/media/stopplay', config.dockingSystemServiceUrl);

// 获取geojson
const queryGeojsonByAdcode = get('/geo/getGeoJsonByAdcode', config.commonServiceUrl);

// 旅游包车-旅客流量
const queryTravelThroughout = get('/travel/analysis/throughout', config.resourceUrl);

// 旅游包车-旅客近5日吞吐量
const queryTravelFiveThroughout = get('/travel/analysis/fiveThroughout', config.resourceUrl);

// 旅游包车-在途车辆数
const queryTravelOnWayCar = get('/travel/analysis/onWayCar', config.resourceUrl);

// 旅游包车-基本数据
const queryTravelBasic = get('/travel/analysis/basic', config.resourceUrl);

// 旅游包车-游客流量分析
const queryTravelAnalysisTraveller = get('/travel/analysis/traveller', config.resourceUrl);

// 旅游包车-热点线路排名
const queryTravelAnalysisHotRoute = get('/travel/analysis/hotRoute', config.resourceUrl);

// 班线-今日旅客流向
const queryPassengerFlowService = get('/classBus/analysis/passenger/flow', config.resourceUrl);

// 班线-近5日旅客吞吐量
const queryPassengerThroughputService = get(
  '/classBus/analysis/nearlyFiveDay/throughput',
  config.resourceUrl,
);

// 班线-获取在途车辆流向统计
const queryVehicleFlowStatService = get(
  '/classBus/analysis/realTime/vehicle/flow/stat',
  config.resourceUrl,
);

// 班线-近7日班线展板情况
const queryBusWeekInfoService = get('/classBus/analysis/nearly/week/info', config.resourceUrl);

// 班线-客流量统计
const queryPassengerFlowStatService = get(
  '/classBus/analysis/passenger/flow/stat',
  config.resourceUrl,
);

// 班线-客流量年龄分布
const queryPassengerAgeStatService = get(
  '/classBus/analysis/passenger/flow/age/stat',
  config.resourceUrl,
);

// 查询行业线路列表
const queryRouteListService = get('/bus/route/queryRoute/page', config.customizationWcUrl);

// 查询行业线路详情
const queryRouteDetailService = get('/bus/route/queryRouteById', config.customizationWcUrl);

// 查询行业线路及其站点
const queryRouteAndSiteService = get('/bus/route/routeAndSites', config.customizationWcUrl);

// 以省为维度，进行车辆信息聚合
const provinceDistributionService = get(
  '/latest/location/provinceDistribution',
  config.terminalUrl,
);

// 指定省份下，以网格为维度进行聚合
const reseauDistributionService = get('/latest/location/reseauDistribution', config.terminalUrl);

// 昌吉视频
const apiChangjiGroupService = get('/api/changji/group', 'http://222.80.229.117:30080');

// 主防展板-主防基础信息
const activeDefBasicDataService = get(
  '/activeDefenseStatistical/activeDefBasicData',
  config.discoveryCenterServiceUrl,
);

// 主防展板-实时主防报警情况卡片详情
const activeDefCardDataService = get(
  '/activeDefenseStatistical/activeDefCardData',
  config.discoveryCenterServiceUrl,
);

// 主防展板-主防报警排名
const activeDefDataRankingService = get(
  '/activeDefenseStatistical/activeDefDataRanking',
  config.discoveryCenterServiceUrl,
);

// 主防展板-实时主防报警情况
const activeDefRealTimeDataService = get(
  '/activeDefenseStatistical/activeDefRealTimeData',
  config.discoveryCenterServiceUrl,
);

// 主防展板-今日主防报警
const activeDefTodayAlarmService = get(
  '/activeDefenseStatistical/activeDefTodayAlarm',
  config.discoveryCenterServiceUrl,
);

// 主防展板-近7日主防报警分级情况
const activeClassificationSituationService = get(
  '/activeDefenseStatistical/alarmClassificationSituation',
  config.discoveryCenterServiceUrl,
);

// 主防展板-基础数据车辆和企业
const boardDefenceAlarmService = get('/alarm/boardDefenceAlarm', config.terminalUrl);

// 文山验收展板-企业展板-企业车均违章类型排名
const vioNumRankService = get(
  '/violation_analyze/stat/violation_rank_of_region',
  config.governanceUrl,
);

// 文山验收展板-企业展板-违章类型排名
const vioTypeRankService = get('/violation_analyze/stat/violation_types', config.governanceUrl);

// 文山验收展板-企业展板-五率日环比
const fiveDayRateService = get('/five/analysis/rate/total', config.serviceUrl);

// 文山验收展板-企业展板-五率排名
const fiveRateRankService = get('/five/analysis/rate/ranking', config.serviceUrl);

// 文山验收展板-企业展板-车均违章数排名
const getViolationRankService = get('/violation/getViolationRank', config.governanceUrl);

// 运营商五率排名 文山第三方监控
const fiveRateRankSortService = get('/fiverate/data/sort', config.discoveryCenterServiceUrl);
// 运营商平台监管规模排名 文山第三方监控
const platformRankService = get(
  '/fiverate/platform/car/data/sort',
  config.discoveryCenterServiceUrl,
);
// 营运商考核(查岗响应率和连通率)文山第三方监控
const platformRateRankService = get('/check/platformType', config.discoveryCenterServiceUrl);
// 安全分数 统计昨日环比的数据  文山企业端
const getSafetyScoreComparedService = get(
  '/safetyScore/getDayOnDayCompared',
  config.commonServiceUrl,
);

export {
  // eslint-disable-next-line import/prefer-default-export
  latestBatchService,
  mapAggregateService,
  queryCarRealTimeFlowService,
  queryCarRoute,
  panelBaseInfoService,
  panelTypeStatService,
  totalExpiredNumService,
  latestBatchStatisticsService,
  fiveRateCountService,
  fiveRateCountCompanyService,
  getSafetyScoreComparedService,
  sevenDayManualHandleSituationService,
  totalAlarmTodayService,
  vehicleRunStatusService,
  aggrVehicleStatusService,
  getListForComparedService,
  queryDangerWayBillchangeService,
  queryWaybillCountGroupbyStatusService,
  queryWaybillCountGroupByTypeService,
  queryAbnormalWaybillNumService,
  queryHotWaybillService,
  queryWaybillFlowChangeService,
  queryVehicleWaybillService,
  capacityMileageService,
  queryBusLineService,
  getListForCarTypeService,
  listByTimeTervalService,
  queryRoadInfoCollectionList,
  queryRandomEnterprise,
  statCarVioTrendService,
  statCarVioTrendByOperateService,
  statWeightAndCommonVioTendService,
  statDrischoolAndRepairVioTendService,
  statRecentlyRehicleExService,
  statCarVioRankService,
  searchSourceEnterpriseService,
  panelMtdvBaseInfoTotalService,
  fiveAnalysisBusRunningService,
  panelBusHotLineService,
  queryCarProblemService,
  queryEnterpriseService,
  querySourceEnterpriseService,
  queryViolationFrequentService,
  vcloudDeviceListService,
  vcloudMediaPlayService,
  vcloudMediaStopplayService,
  queryGeojsonByAdcode,
  queryTravelThroughout,
  queryTravelFiveThroughout,
  queryTravelOnWayCar,
  queryTravelBasic,
  queryTravelAnalysisTraveller,
  queryTravelAnalysisHotRoute,
  queryPassengerFlowService,
  queryPassengerThroughputService,
  queryVehicleFlowStatService,
  queryBusWeekInfoService,
  queryPassengerFlowStatService,
  queryPassengerAgeStatService,
  notFinishedStudy,
  queryRouteListService,
  queryRouteDetailService,
  queryRouteAndSiteService,
  provinceDistributionService,
  reseauDistributionService,
  apiChangjiGroupService,
  activeDefBasicDataService,
  activeDefCardDataService,
  activeDefDataRankingService,
  activeDefRealTimeDataService,
  activeDefTodayAlarmService,
  activeClassificationSituationService,
  boardDefenceAlarmService,
  vioTypeRankService,
  vioNumRankService,
  fiveDayRateService,
  fiveRateRankService,
  fiveRateRankSortService,
  platformRankService,
  platformRateRankService,
  getViolationRankService,
  getBasicInfoStatService,
  queryVioHeatMapService,
  queryVioCarCountService,
  queryVioHeatMapCoarseStatService,
  queryVioHeatMapFineStatService,
};
